import { useEffect, useState } from "react";
import { Col, Container, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { ToolCard } from "../../../../tool-card/tool-card";
import { useDispatch } from "react-redux";
import { AxiosResponse } from "axios";
import { GetToolsSuccessResponse, Tool } from "../../../../../types/api/tool/get-tools-success-response";
import { showLoadingAlertMessage } from "../../../../../../../utils/show-loading-alert-message/show-loading-alert-message";
import { networkCall } from "../../../../../../../utils/network-call/network-call";
import { clearAlertMessage, showAlertMessage } from "../../../../../../../redux/reducer/alert-message.reducer";
import { getImageUrl } from "../../../../../../../utils/image-helper/get-image-url";

type ToolChooserModalProps = {
    isModalOpen: boolean;
    onChooseTool: (tool: Tool) => void;
    onToggleModal: (isOpen?: boolean) => void;
    selectedToolId: number | null;
};

export const ToolChooserModal = ({ isModalOpen, onChooseTool, onToggleModal, selectedToolId }: ToolChooserModalProps) => {
    const [tools, setTools] = useState<Tool[]>([]);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isModalOpen) {
            let ignore = false;

            const getData = async () => {
                showLoadingAlertMessage();
                const response = await networkCall('/tools');

                dispatch(clearAlertMessage());

                if (ignore) return;

                if (!response || response.status !== 200) {
                    dispatch(showAlertMessage({
                        alertMessageType: 'error',
                        alertMessageText: 'Hiba történt a szerszámok lekérdezése közben. Kérjük, próbálja újra!'
                    }));
                    return;
                }

                const res: AxiosResponse<GetToolsSuccessResponse> = response;
                setTools(res.data.tools);
            };

            getData();

            return () => {
                ignore = true;
            };
        }
    }, [isModalOpen, dispatch]);

    const handleChooseTool = (toolId: number) => {
        const tool = tools.find(tool => tool.id === toolId);
        if (!tool) return;
        onChooseTool(tool);
    };

    return (
        <Modal isOpen={isModalOpen} toggle={() => onToggleModal()} size='lg'>
            <ModalHeader className="d-block">
                <div className="d-flex justify-content-between align-items-center blue-font">
                    <b>Szerszám kiválasztása</b>
                    <img
                        style={{ width: '50px', padding: '10px 10px 0 0' }}
                        src={getImageUrl('close-button.png')}
                        alt="close-button"
                        title="Bezárás"
                        className="cursor-pointer"
                        onClick={() => onToggleModal(false)}
                    />
                </div>
            </ModalHeader>
            <ModalBody>
                <Container>
                    <Row>
                        {
                            tools.map((tool) => (
                                <Col xs={6} sm={4} key={tool.id}>
                                    <ToolCard
                                        tool={tool}
                                        type='chooser'
                                        onChoose={() => handleChooseTool(tool.id)}
                                        selected={tool.id === selectedToolId}
                                    />
                                </Col>
                            ))
                        }
                    </Row>
                </Container>
            </ModalBody>
        </Modal>
    );
};